export default __webpack_public_path__ + "static/media/current-projects-empty-state.525018d9.svg";